import { clasolSuiteApi } from '../axiosConfig'
import { buildListParams, withSuiteAdminCode } from '../apiHelpers'

export const getAuditEvents = async (params) => {
  const { data } = await clasolSuiteApi.get('/audit', {
    params: buildListParams({ sortDirection: 'desc', ...params }),
    ...withSuiteAdminCode(),
  })
  return data
}
